import { REFERRAL_INFO } from '../../axios/appiendPoints';
import { axiosInstanceNext } from '../../axios/axios';

export const fetchReferralInfo = async (rest_id) => {
  const params = new URLSearchParams();
  params.append('restaurant_id', rest_id);
  const res = await axiosInstanceNext.post(REFERRAL_INFO, params);
  return res.data.data;
};
